import { Controller } from "@hotwired/stimulus"

// Formats a text input live (prefix + thousand + decimal) and keeps a hidden input
// with the raw numeric value for form submission.
//
// Replica react-number-format (frontend) para inputs de moneda.
//
// Uso en ERB (ver currency_prices_helper):
//   <span data-controller="manage--number-format"
//         data-manage--number-format-prefix-value="$"
//         data-manage--number-format-thousand-value="."
//         data-manage--number-format-decimal-value=",">
//     <input type="text" inputmode="decimal"
//            data-manage--number-format-target="display"
//            data-action="input->manage--number-format#format">
//     <input type="hidden" name="prices[CLP]" value="10000"
//            data-manage--number-format-target="raw">
//   </span>

export default class extends Controller {
  static targets = ["display", "raw"]
  static values = {
    prefix: { type: String, default: "" },
    thousand: { type: String, default: "," },
    decimal: { type: String, default: "." }
  }

  format() {
    const parsed = this.parse(this.displayTarget.value)
    this.rawTarget.value = parsed.raw
    this.displayTarget.value = parsed.display
  }

  parse(input) {
    if (input == null || input === "") return { raw: "", display: "" }

    const prefix = this.prefixValue
    const thousand = this.thousandValue
    const decimal = this.decimalValue

    let cleaned = String(input)
    if (prefix) cleaned = cleaned.split(prefix).join("")
    if (thousand) cleaned = cleaned.split(thousand).join("")

    const allowed = new RegExp(`[^0-9${this.escape(decimal)}]`, "g")
    cleaned = cleaned.replace(allowed, "")

    const parts = cleaned.split(decimal)
    const intPart = (parts[0] || "").replace(/^0+(?=\d)/, "")
    const decPart = parts.length > 1 ? parts.slice(1).join("") : null

    if (intPart === "" && decPart === null) return { raw: "", display: "" }

    const raw = decPart !== null ? `${intPart || "0"}.${decPart}` : intPart
    const intWithThousands = this.applyThousands(intPart || "0", thousand)
    const display = prefix + (decPart !== null ? `${intWithThousands}${decimal}${decPart}` : intWithThousands)

    return { raw, display }
  }

  applyThousands(intStr, sep) {
    if (!sep) return intStr
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep)
  }

  escape(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }
}
